import React from "react";
import PropTypes from "prop-types";

const Text = ({ text }) =>
  text.length > 160 ? `${text.substring(0, 160)}...` : text;
const Item = ({ data, onDelete, onEdit }) => (
  <div>
    <div className="row">
      <div className="col-md-8">
        <div>
          <strong>{data.name}</strong>
        </div>
        <div>
          <Text text={data.message} />
        </div>
      </div>
      <div className="col-md-4 text-right">
        <button data-id={data.id} className="btn btn-text" onClick={onEdit}>
          EDIT
        </button>
        &nbsp;
        <button data-id={data.id} className="btn btn-text" onClick={onDelete}>
          DELETE
        </button>
      </div>
    </div>
    <hr />
  </div>
);

Item.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func
};

export default Item;
